import {useSelector,useDispatch} from 'react-redux'
import {
	getEditableClientMenu,
	createMenuGroup,
	removeMenuGroup,
	editMenuGroup,
	arrangeMenu,
	resetMenu,
	getMenu,
} from './slice'

export const useCreateMenuGroup = ()=>{
	const dispatch = useDispatch()
	const create = payload => {
		return dispatch(createMenuGroup(payload))
	}
	return create
}

export const useEditMenuGroup = ()=>{
	const dispatch = useDispatch()
	const edit = payload => {
		return dispatch(editMenuGroup(payload))
	}
	return edit
}

export const useRemoveMenuGroup = ()=>{
	const dispatch = useDispatch()
	const remove = payload => {
		return dispatch(removeMenuGroup(payload))
	}
	return remove
}

export const useArrangeMenu = ()=>{
	const dispatch = useDispatch()
	const arrange = (payload)=>dispatch(arrangeMenu(payload))
	return arrange
}

export const useResetMenu = ()=>{
	const dispatch = useDispatch()
	const reset = (payload)=>dispatch(resetMenu(payload))
	return reset
}

export const useMenu = ()=>{
	const dispatch = useDispatch()
	const {status,items} = useSelector(state=>state.customizationDashboard.menu)
	const params = new URLSearchParams(window.location.search)
	const isPublic = Boolean(params.get('is_public_api_request'))
	if(status==='init'&&!isPublic) dispatch(getMenu())
	return {status,items}
}

export const useClientMenu = ()=>{
	const dispatch = useDispatch()
	const {status,enabled,disabled} = useSelector(state=>state.customizationDashboard.clientMenu)
	if(status==='init') dispatch(getEditableClientMenu())

	const disabledWithPath = disabled.map((item,i)=>{


		const path = [item.enabled^1,i]
		const itemWithPath = {
			...item,
			path
		}
		if(item.item_type==='menu_group'){
			itemWithPath.nav_items = item.nav_items.map((subItem,i)=>{
				const subPath = [...path,i]
				return {
					...subItem,
					path:subPath
				}
			})
		}
		return itemWithPath
	})
	const enabledWithPath = enabled.map((item,i)=>{


		const path = [item.enabled^1,i]
		const itemWithPath = {
			...item,
			path
		}
		if(item.item_type==='menu_group'){
			itemWithPath.nav_items = item.nav_items.map((subItem,i)=>{
				const subPath = [...path,i]
				return {
					...subItem,
					path:subPath
				}
			})
		}
		return itemWithPath
	})

	return {status,enabled:enabledWithPath,disabled:disabledWithPath}
}